import React from 'react';
import * as Icon from 'react-feather';
import { getAllowedModules, ROLE_MODULE_ACCESS } from '../utils/roleBasedAccess';

// Menu definitions
const ALL_MENUS = {
  'Admin Dashboard': {
    label: 'Admin Dashboard',
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: 'Admin Dashboard',
    submenuItems: [
      {
        label: 'Dashboard',
        link: '/admin-dashboard',
        icon: <Icon.Box />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Planner Dashboard',
        link: '/plannerdashboard',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Notification Events',
        link: '/notifications/events',
        icon: <Icon.Bell />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  'Customer Dashboard': {
    label: 'Customer Dashboard',
    submenuOpen: true,
    submenuHdr: 'Customer Dashboard',
    link: '/sales-dashboard',
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Shipments',
        link: '/shipments',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  'Warehouse Management System': {
    label: 'Warehouse Management System',
    submenuOpen: true,
    submenuHdr: 'Warehouse Management',
    link: '/warehouse',
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Shipping',
        link: '/shipment-tile',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Receiving',
        link: '/mappings',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Purchase Order',
        link: '/pos',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Inventory',
        link: '/inventory-tile',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Inventory Cycle Count',
        link: '/inventory-scanning',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Part',
        link: '/part-master',
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },

    ],
  },
  'Quality Management System': {
    label: 'Quality Management System',
    submenuOpen: true,
    submenuHdr: 'Quality Management',
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Quality Inspection',
        link: '/inspectionplan-tile',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Approve/Reject',
        link: '/quality-approval',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Inspection Results',
        link: '/inspection-results',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      }, {
        label: 'Quality Alert Pages',
        link: '/quality-alert-pages',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      }, {
        label: 'Change Request',
        link: '/change-request',
        icon: <Icon.GitPullRequest />,
        showSubRoute: false,
        submenu: false,
      }, {
        label: 'CIP Register',
        link: '/cip-register',
        icon: <Icon.CheckCircle />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  'Production Management System': {
    label: 'Production Management System',
    submenuOpen: true,
    submenuHdr: 'Production Management',
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Production',
        link: '/production',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Planner',
        link: '/plannerv2',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Planning Workspace',
        link: '/planning-workspace',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },

    ],
  },
  'Mold Management System': {
    label: 'Mold Management System',
    submenuOpen: true,
    submenuHdr: 'Mold Management',
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Mold Receiving',
        link: '/mold-receiving',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Mold Maintenance',
        link: '/mold-maintenance',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Mold Release',
        link: '/mold-release',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Future Actions',
        link: '/future-actions',
        icon: <Icon.Clock />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  'Asset Management System': {
    label: 'Asset Management System',
    submenuOpen: true,
    submenuHdr: 'Asset Management',
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Machine',
        link: '/cell',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Auxiliary Equipment',
        link: '/auxiliary-equipment',
        icon: <Icon.Settings />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Forklift',
        link: '/forklift',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Water Towers',
        link: '/water-towers',
        icon: <Icon.Droplet />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Air Compressors',
        link: '/air-compressors',
        icon: <Icon.Wind />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Plant',
        link: '/plant',
        icon: <Icon.Home />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Robots',
        link: '/robots',
        icon: <Icon.Cpu />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Overhead Crane',
        link: '/overhead-crane',
        icon: <Icon.Zap />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  'Masters': {
    label: 'Masters',
    submenuOpen: true,
    submenuHdr: 'Masters',
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'Material',
        link: '/stock-transfer',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Planner V2',
        link: '/plannerv2',
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
      },
      /* {
         label: 'Mold',
         link: '/Mold',
         external: true,
         icon: <Icon.Truck />,
         showSubRoute: false,
         submenu: false,
       },
       {
         label: 'Machine',
         link: '/machine',
         icon: <Icon.Truck />,
         showSubRoute: false,
         submenu: false,
       },*/
      {
        label: 'Customer',
        link: '/customer-master',
        icon: <Icon.ShoppingCart />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Carrier',
        link: '/carrier-master',
        icon: <Icon.Truck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Vendors',
        link: '/vendor-master',
        icon: <Icon.ShoppingCart />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Location',
        link: '/location-master',
        icon: <Icon.Copy />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Material',
        link: '/material',
        icon: <Icon.HardDrive />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  /*'Settings': {
    label: 'Settings',
    submenuOpen: true,
    submenuHdr: 'Settings',
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: 'User',
        link: '/users',
        icon: <Icon.User />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Role',
        link: '/roles',
        icon: <Icon.Shield />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Notification',
        link: '/notifications',
        icon: <Icon.Bell />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: 'Log',
        link: '/logs',
        icon: <Icon.List />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },*/
};

// Define the display order of the menu items
const MENU_ORDER = [
  'Admin Dashboard',
  'Customer Dashboard',
  'Warehouse Management System',
  'Production Management System',
  'Quality Management System',
  'Mold Management System',
  'Asset Management System',
  'Masters',
];

// Function to get menu items based on role
export const getMenuItems = () => {
  let roles = [];
  try {
    const raw = sessionStorage.getItem('MSAL_LAST_IDTOKEN_CLAIMS');
    if (raw) {
      const claims = JSON.parse(raw);
      roles = Array.isArray(claims?.roles) ? claims.roles : [];
      //console.log('Roles from MSAL:', roles);
    }
  } catch (_err) {
    console.error('Error parsing MSAL claims:', _err);
  }

  // Get allowed modules for the user's roles
  const allowedModules = getAllowedModules(roles);

  if (roles.length > 0) {
    console.log('SidebarData Debug: Roles found:', roles);
    console.log('SidebarData Debug: Allowed modules:', allowedModules);

    // Detailed Debugging for mismatches
    if (allowedModules.length === 0) {
      console.warn('SidebarData Warning: Roles exist but no modules allowed.');
      console.log('SidebarData Debug: Available Roles in System:', Object.keys(ROLE_MODULE_ACCESS));
      roles.forEach(userRole => {
        console.log(`SidebarData Debug: Checking role '${userRole}' against system roles...`);
        if (ROLE_MODULE_ACCESS[userRole]) {
          console.log(`SidebarData Debug: Role '${userRole}' MATCHES.`);
        } else {
          console.log(`SidebarData Debug: Role '${userRole}' does NOT match any system role key.`);
        }
      });
    }
  }

  // Filter and return only the allowed menus in the specified order
  const menuItems = MENU_ORDER
    .filter(moduleKey => allowedModules.includes(moduleKey))
    .map(moduleKey => {
      const menu = ALL_MENUS[moduleKey];
      if (!menu) {
        console.warn(`SidebarData Warning: Module '${moduleKey}' allowed but not found in ALL_MENUS.`);
      }
      return menu;
    })
    .filter(menu => menu !== undefined); // Ensure we don't return undefined for missing keys

  if (roles.length > 0 && menuItems.length === 0) {
    console.log('SidebarData Debug: Roles exist but no menu items returned. Check ALL_MENUS keys vs MODULES constants.');
  }

  return menuItems;
};

// Export the menu data getter function
export const SidebarData = getMenuItems;
